/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Lowestpricedecrease2Inputs */

const he_statistics_lowestpricedecrease2 = /** @type {(inputs: Statistics_Lowestpricedecrease2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידות מחיר למחיר הנמוך ביותר`)
};

const en_statistics_lowestpricedecrease2 = /** @type {(inputs: Statistics_Lowestpricedecrease2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drops to lowest price`)
};

/**
* | output |
* | --- |
* | "Price drops to lowest price" |
*
* @param {Statistics_Lowestpricedecrease2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_lowestpricedecrease2 = /** @type {((inputs?: Statistics_Lowestpricedecrease2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Lowestpricedecrease2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_lowestpricedecrease2(inputs)
	return en_statistics_lowestpricedecrease2(inputs)
});
export { statistics_lowestpricedecrease2 as "statistics_lowestPriceDecrease" }